import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=5bd94cd6&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style1 from "./menu.vue?vue&type=style&index=1&id=5bd94cd6&prod&scoped=true&lang=css"
import style2 from "./menu.vue?vue&type=style&index=2&id=5bd94cd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd94cd6",
  null
  
)

export default component.exports